import filters from "@/mixins/filters";
import OAProp from "@/components/OAProp/OAProp";

const contractColumns = [{
    title: "合同编码",
    key: "contractCode"
  },
  {
    title: "合同属性",
    key: "natureName",
  },
  {
    title: "归属公司",
    key: "companyName",
    minWidth: 250,
    showOverflowTooltip: true
  },
  {
    title: "劳动关系所在地区",
    key: "attributionName",
    minWidth: 150,
  },
  {
    title: "开始日期",
    key: "startTime",
    formatter: function (row, column, cellValue, index) {
      if (cellValue) {
        return cellValue.split(' ')[0]
      }
    }
  },
  {
    title: "结束日期",
    key: "endTime",
    formatter: function (row, column, cellValue, index) {
      if (cellValue) {
        return cellValue.split(' ')[0]
      }
    }
  },
  {
    title: "合同岗位",
    key: "station"
  },
  {
    title: "合同状态",
    key: "invalidState",
    component: {
      name: OAProp,
    },
  },
]

const familyColumns = [{
    title: "与本人关系",
    key: "relationship"
  }, {
    title: "姓名",
    key: "name"
  },
  {
    title: "工作单位",
    key: "workUnit",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  },
  {
    title: "职务",
    key: "duties",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  },
  {
    title: "联系电话",
    key: "telephone",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  },
]

const educateColumns = [{
    title: "开始时间",
    key: "startTime",
    formatter: function (row, column, cellValue, index) {
      if (cellValue) {
        return cellValue.split(' ')[0]
      }
    }
  },
  {
    title: "结束时间",
    key: "endTime",
    formatter: function (row, column, cellValue, index) {
      if (cellValue) {
        return cellValue.split(' ')[0]
      }
    }
  },
  {
    title: "毕业院校",
    key: "school"
  },
  {
    title: "专业",
    key: "major",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  },
  {
    title: "学历",
    key: "educationName"
  },
  {
    title: "学历性质",
    key: "natureName"
  },
]

const workColumns = [{
    title: "开始时间",
    key: "startTime",
    formatter: function (row, column, cellValue, index) {
      if (cellValue) {
        let t = cellValue.split('-');
        return t[0] + '-' + t[1]
      }
    }
  },
  {
    title: "结束时间",
    key: "endTime",
    formatter: function (row, column, cellValue, index) {
      if (cellValue) {
        let t = cellValue.split('-');
        return t[0] + '-' + t[1]
      }
    }
  },
  {
    title: "工作单位",
    key: "workUnit"
  },
  {
    title: "部门及职务",
    key: "deparPosition"
  },
  {
    title: "薪资",
    key: "salary",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  },
  {
    title: "证明人",
    key: "reterence",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  },
  {
    title: "联系电话",
    key: "telephone",
    formatter: (row, column, cellValue, index) => {
      return filters.isEmpty(cellValue);
    }
  }
]


const evaluateColumns = [{
    key: "interviewerName",
    title: "面试人"
  },
  {
    key: "syntheticEvaluationName",
    title: "综合评价"
  },
  {
    key: "interiewResultName",
    title: "面试结论"
  }, {
    key: "remark",
    title: "面试评语"
  }
]

const contractHandle = {
  custom: [{
    emit: "custom-fei",
    icon: "iconfont icon-zuofei",
    type: "warning",
    show: function (index, row) {
      return row.invalidState == 1 ? false : true
    }
  }, {
    emit: "custom-emit",
    icon: "iconfont icon-bianji",
    type: "primary",
    show: function (index, row) {
      return row.invalidState == 1 ? false : true
    }
  }, {
    emit: "custom-del",
    icon: "iconfont icon-shanchu",
    type: "danger"
  }]
}

const familyHandle = {
  custom: [{
    emit: "custom-emit",
    icon: "iconfont icon-bianji",
    type: "primary"
  }, {
    emit: "custom-del",
    icon: "iconfont icon-shanchu",
    type: "danger"
  }]
}

const educateHandle = {
  custom: [{
    emit: "custom-emit",
    icon: "iconfont icon-bianji",
    type: "primary"
  }, {
    emit: "custom-del",
    icon: "iconfont icon-shanchu",
    type: "danger"
  }]
}

const workHandle = {
  custom: [{
    emit: "custom-emit",
    icon: "iconfont icon-bianji",
    type: "primary"
  }, {
    emit: "custom-del",
    icon: "iconfont icon-shanchu",
    type: "danger"
  }]
}

const evaluateHandle = {
  custom: [{
    emit: "custom-emit",
    icon: "iconfont icon-bianji",
    type: "primary"
  }]
}

export default {
  contractColumns,
  familyColumns,
  educateColumns,
  workColumns,
  evaluateColumns,
  contractHandle,
  familyHandle,
  educateHandle,
  workHandle,
  evaluateHandle
}



// WEBPACK FOOTER //
// ./src/components/otherTable/columns.js